import React from "react";
import styled, {useTheme} from "styled-components";
import {Button} from "@ui";

export default function OutlinedButton(props) {
  const theme = useTheme();

  return (
    <Container>
      <Button
        {...props}
        styles={styles(theme)}
        label={props.label}
        variant="secondary"
        size="large"
        type={props.type}
        disabled={props.disabled}
        LeftIconComponent={props.LeftIconComponent}
        RightIconComponent={props.RightIconComponent}
        onClick={props.onClick}
        to={props.to}
      />
    </Container>
  );
}

const styles = theme => {
  return {
    root: {
      fontSize: theme.v2.typography.sizing.l.lg,
      fontFamily: theme.v2.typography.bodyText1.family,
      border: `1px solid ${theme.v2.color.primary}`,
      borderRadius: theme.v2.decoration.border.radius.default,
      fontWeight: theme.v2.typography.bodyText1.weight.heavy,
      textTransform: "capitalize",
      width: "100%",
    },
    secondary: {
      backgroundColor: "#fff",
      color: theme.v2.color.typography.title1,
    },
    large: {
      padding: `${theme.v2.spacing(4)}`,
      height: "50px",
    },
  };
};

const Container = styled.div`
  display: block;
  width: 100%;
`;
